<template>
    <div class="content_con">
        <p class="text-center"><span class="title">东进公司消杀药品、空气治理药品</span></p>
        <p class="text-center margin-bottom-21"><span class="title">采购项目询价公告</span></p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">一、项目信息</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、项目名称：<span class="underline">广东东进有害生物防控技术有限公司消杀药品采购项目；</span></span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span>、项目编号：</span>
            <span>DJFK-XS-05-01-001（2024）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">3</span>
            <span class="content">、采购范围：<span class="underline">林业消杀药品、空气治理药品；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">4</span>
            <span class="content">、项目地点：<span class="underline">采购人指定交货地址；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">5</span>
            <span class="content">、服务时间（供货时间/工期）：<span class="underline">合同签订日起订</span></span>
            <span class="underline"><span class="number">2</span></span>
            <span class="underline"><span class="content">年；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">6</span>
            <span class="content">、</span>
            <span class="content colorblack">
                采购人所采购的药品消杀用品包括但不限于清单所列产品，供应商必须清楚理解：本协议采购项目的取得并不意味着必然获得单项采购项目的服务机会，采购人无法预计且无法保证中标人所能获得的数量和采购金额。在服务期限内，根据采购服务项目的具体情况，采购方仍有权通过其他合法方式选择中标供应商之外的其他单位提供本采购文件的服务内容。
            </span>

        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">7</span>
            <span class="content">、</span>
            <span class="content colorblack"> 采购人所采购的货物包括但不限于报价表中产品，若采购的货物未列明的，则由采购方和中标供应方双方协商一致后进行采购。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">二、采购说明及需求清单</span></p>
        <p class="text-left text-indent-37 line-height-39"><span
                class="content">本项目共有2包。A1包共需采购产品1项，A2包共需采购产品1项。采购具体内容及要求详见附件。</span></p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">三、项目发布</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、本项目在东莞实业投资控股集团有限公司-招标采购栏目：</span>
            <span class="content">
                <a class="fa" href="http://www.dgsy.com.cn/">http://www.dgsy.com.cn/发布。</a></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">2</span>
            <span class="content">、网上公示期限为</span>
            <span class="number">5</span>
            <span class="content">天，即</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">12</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">4</span></span>
            <span class="underline"><span class="content">日至</span></span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">12</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">9</span></span>
            <span class="underline"><span class="content">日</span></span>
            <span class="content">。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">四、响应人资格要求</span></p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">1</span>
            <span
                class="content">、响应人须为在中华人民共和国境内登记注册的具有独立承担民事责任能力的法人或其他组织。【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span class="content">、未被列入东实集团及下属企业相关领域黑名单。【以东莞实业投资控股集团有限公司发文（东实通〔</span>
            <span class="number">2021</span>
            <span class="content">〕</span>
            <span class="number">44</span>
            <span class="content">号）、（东实通〔</span>
            <span class="number">2021</span>
            <span class="content">〕</span>
            <span class="number">98</span>
            <span class="content">号）、（东实通〔</span>
            <span class="number">2022</span>
            <span class="content">〕</span>
            <span class="number">75</span>
            <span class="content">号）（东实通〔</span>
            <span class="number">2023</span>
            <span class="content">〕</span>
            <span class="number">37</span>
            <span class="content">号）和下属公司发文为准，如有最新发文通知，按最新文件执行。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">3</span>
            <span class="content">、供应商未被列入</span>
            <span class="content">“</span>
            <span class="content">信用中国</span>
            <span class="content">”</span>
            <span class="content">网站（</span>
            <span class="content">https://www.creditchina.gov.cn/)“</span>
            <span class="content">记录失信被执行人或重大税收违法案件当事人名单或政府采购严重违法失信行为</span>
            <span class="content">”</span>
            <span class="content">记录名单；同时，不处于中国政府采购网（</span>
            <span class="content">http://www.ccgp.gov.cn/</span>
            <span class="content">）</span>
            <span class="content">“</span>
            <span class="content">政府采购严重违法失信行为信息记录</span>
            <span class="content">”</span>
            <span class="content">中的禁止参加政府采购活动期间；以及未被工商行政管理机关在</span>
            <span class="content">“</span>
            <span class="content">国家企业信用信息公示系统</span>
            <span class="content">”</span>
            <span class="content">网站（</span>
            <span class="content">www.gsxt.gov.cn</span>
            <span class="content">）中列入严重违法失信企业名单；（需提供以上网址网上查询认证渠道截图，截图必须显示供应商单位名称并加盖公章。）</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">4</span>
            <span class="content">、三年内有同等类型物品或服务配送经验，有不少于3家同等类型配送经验，无不良记录，以合同关键页或交易发票作为业绩证明。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">5</span>
            <span class="content">、需提供售后服务承诺书。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">五、报价</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">采购限价：按清单分项报价（不含税）及汇总，报价应精确到2位小数点。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">六、定标方法</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span
                class="content">本次项目采用询价方式进行采购，询价小组对各供应商响应文件进行审核，并根据质量和服务均能满足采购文件实质性响应要求且报价最低的原则，推荐成交候选供应商。如有效投标不足3家时，采购失败，A1包确定报价最低的前三名为中标单位，A2包确定报价最低前两名为中标单位。</span>
        </p>
        <el-table :data="tableData" style="width: 100%;" border>
            <el-table-column prop="purchasePackage" label="采购包号" />
            <el-table-column prop="projectContent" label="项目内容" />
            <el-table-column prop="serviceUnitQuantity" label="采购服务单位数量" />
            <el-table-column prop="serviceTerm" label="服务期限" />
        </el-table>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">七、响应文件的组成部分</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">（响应文件本项资料如有不全，则作无效报价处理）</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">1</span>
            <span class="content">、报价清单；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span class="content">、法定代表人身份证复印件；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">3</span>
            <span class="content">、法人授权委托书（模板）及被委托人身份证复印件；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">4</span>
            <span class="content">、承诺函（模板）；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">5</span>
            <span class="content">、安全及环保承诺书（模板）；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">6</span>
            <span class="content">、符合“响应人资格要求”对应的证明资料；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">7</span>
            <span class="content">、响应人认为需要提供的其他资料。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">响应人须严格按照采购人提供的表单格式报价，响应文件必须装订完整，于骑缝处加盖投标单位企业公章。装有响应文件的文件袋须贴有密封条，于骑缝处加盖企业公章。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">八、开标时间及开标地址</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">投标文件递交截止时间：</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">12</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">9</span></span>
            <span class="underline"><span class="content">日上午</span></span>
            <span class="underline"><span class="number">10:30</span></span>
            <span class="content">（星期一）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">开标时间：</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">12</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">9</span></span>
            <span class="underline"><span class="content">日上午</span></span>
            <span class="underline"><span class="number">10:30</span></span>
            <span class="content">（星期一）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">开标地址：<span class="underline">东莞市南城街道中天商业街</span></span>
            <span class="underline"><span class="number">28</span></span>
            <span class="underline"><span class="content">号</span></span>
            <span class="underline"><span class="number">1</span></span>
            <span class="underline"><span class="content">栋</span></span>
            <span class="underline"><span class="number">209</span></span>
            <span class="underline"><span class="content">室东进公司</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">联系人：翟智伟（</span>
            <span class="number">13829104552</span>
            <span class="content">）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">九、注意事项</span></p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">1</span>
            <span class="content">、本项目响应人可以以现场送达或快递寄送等方式递交响应文件。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="content">收件地址：东莞市南城街道中天商业街28号1栋209室东进公司</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="content">收件人：翟智伟（13829104552）</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="content">无论响应人以何种方式递交响应文件，若响应人未在开标时间前将文件送达现场，视为放弃投标资格。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span class="content">、采购人向响应人提供的有关资料和数据，是采购人现有的能使响应人利用的资料，采购人对响应人由此而做出的推论、理解和结论概不负责。</span>
        </p>
        <p>（具体详见附件）</p>
        <p class="text-center text-indent-243 line-height-39">
            <span class="content">广东东进有害生物防控技术有限公司</span>
        </p>
        <p class="text-center text-indent-336 line-height-39">
            <span class="number">2024</span>
            <span class="content">年</span>
            <span class="number">12</span>
            <span class="content">月</span>
            <span class="number">3</span>
            <span class="content">日</span>
        </p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"></a><a
                class="file-link" href="/20241203/01/东进公司消杀药品采购项目询价文件.docx"
                title="东进公司消杀药品采购项目询价文件.docx">东进公司消杀药品采购项目询价文件.docx</a></p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"></a><a
                class="file-link" href="/20241203/01/东进公司消杀药品采购项目询价文件.pdf"
                title="东进公司消杀药品采购项目询价文件.pdf">东进公司消杀药品采购项目询价文件.pdf</a></p>
    </div>
</template>
<script>
export default {
    name: "DocDisplay",
    data() {
        return {
            tableData: [
                { purchasePackage: 'A1', projectContent: '林业防制药品', serviceUnitQuantity: '3 家', serviceTerm: '2 年' },
                { purchasePackage: 'A2', projectContent: '甲醛治理药品', serviceUnitQuantity: '2 家', serviceTerm: '2 年' }
            ]
        };
    },
};
</script>

<style lang="scss" scoped>
.content_con {
    font-size: 14px;
    font-family: "宋体", Arial;
    padding: 0px 50px;
    color: #515050;

    .colorblack {
        font-weight: bold !important;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    .fa {
        color: #333;
        font-size: 12px;
    }

    .line-height-2em {
        line-height: 2em;
    }

    .text-center {
        text-align: center;
    }

    .margin-bottom-21 {
        margin-bottom: 21px;
    }

    .title {
        font-size: 27px;
        font-family: 方正小标宋简体;
    }

    .text-indent-37 {
        text-indent: 37px;
    }

    .line-height-39 {
        line-height: 39px;
    }

    .content {
        font-weight: 200;
        font-size: 19px;
        font-family: 仿宋_GB2312;
    }

    .heading {
        font-size: 19px;
        font-family: 黑体;
    }

    .number {
        font-size: 19px;
        font-family: 'Times New Roman', 'serif';
    }

    .underline {
        text-decoration: underline;
    }

    .text-left {
        text-align: left;
    }

    .text-autospace {
        margin: 3px;
        padding: 3px;

        span {
            color: #515050;
            font-size: 14px !important;
        }
    }

    .icon {
        vertical-align: middle;
        margin-right: 2px;
    }

    .file-link-box {
        margin: 3px;
        padding: 3px;
        font-size: 14px;
        text-indent: 22px;
        line-height: 16px;
    }

    .file-link {
        font-size: 12px;
        color: #0066cc;
    }
}
</style>